export default {"src":"/_next/static/media/BE.e1ff99ed.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};